export default {"src":"/pro/_next/static/media/blur.d0c825bc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};